import { IconProps } from "./";
import Icon from "./assets/bell_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Bell(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
